// Maps audit_log.entity_type → a function returning the FE route for that
// entity. Track 6 uses this for click-through from the audit log viewer.
//
// Some entity types are admin-driven singletons (app_config) or compound
// (snapshot amendments) and therefore don't deep-link cleanly. Those return
// null and the UI renders the entity_id as plain text.

export type EntityRouteFn = (entityId: string) => string | null;

export const ENTITY_ROUTES: Record<string, EntityRouteFn> = {
  user: (id) => `/admin/users?highlight=${encodeURIComponent(id)}`,
  account: (id) => `/accounts/${encodeURIComponent(id)}`,
  tester: (id) => `/testers/${encodeURIComponent(id)}`,
  frt_customer: (id) => `/customers/${encodeURIComponent(id)}`,
  product_type: () => `/admin/lookups`,
  account_type: () => `/admin/lookups`,
  frt_category: () => `/admin/lookups`,
  upload: (id) => `/tiller/history?highlight=${encodeURIComponent(id)}`,
  monthly_snapshot: (id) => `/snapshots?highlight=${encodeURIComponent(id)}`,
  app_config: () => `/admin/config`,
  report_template: (id) => `/reports/templates?highlight=${encodeURIComponent(id)}`,
  balance: () => null, // No deep-link target; balances live under their account
  // unknown entity types fall through and are rendered as plain text
};

export function entityHref(entityType: string, entityId: string): string | null {
  const fn = ENTITY_ROUTES[entityType];
  return fn ? fn(entityId) : null;
}
